__turbopack_context__.v({
  "video_image": "G_PNxG_video_image",
  "video_player_container": "G_PNxG_video_player_container",
  "video_player_iframe": "G_PNxG_video_player_iframe",
});
